var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class DirectoryPlace extends Component {
    constructor() {
        super('DirectoryPlace', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('#directory-map').length > 0) {
                this.initInteractions();
                this.initMap();
            }
            this.success();
        });
    }
    initInteractions() {
        $('#btn-toggle-map').on('click', (event) => {
            event.preventDefault();
            $('#directory-map').toggleClass('opacity-0 pe-none');
            $('#btn-toggle-map span').toggleClass('d-none');
            $('.filemaker-list-container').toggleClass('col-lg-10 col-xl-8 col-lg-4');
            $('.filemaker-list-container').parent().toggleClass('justify-content-center justify-content-start');
            $('.filemaker-list').toggleClass('is-reduced');
            if ($('.filemaker-list').hasClass('is-reduced')) {
                $('#directory-map').removeClass('d-none');
                $('.filemaker-list').css('height', $('#directory-map').height());
            }
            else {
                $('#directory-map').addClass('d-none');
                $('.filemaker-list').css('height', 'auto');
            }
            sessionStorage.setItem('directory_map_visible', $('#directory-map').hasClass('opacity-0') ? 'false' : 'true');
        });
        $('.filemaker-list').on('mouseover', '[data-place]', (event, element) => {
            const placeId = element.attr('data-place-id');
            const marker = DirectoryPlace.markers.find((m) => m.getElement().getAttribute('data-place-id') === placeId);
            if (marker) {
                marker.getElement().classList.add('highlighted');
            }
        }).on('mouseout', '[data-place]', (event, element) => {
            const placeId = element.attr('data-place-id');
            const marker = DirectoryPlace.markers.find((m) => m.getElement().getAttribute('data-place-id') === placeId);
            if (marker) {
                marker.getElement().classList.remove('highlighted');
            }
        });
    }
    initMap() {
        DirectoryPlace.map = new maplibregl.Map({
            container: $('#directory-map').get(0),
            style: 'https://vectortiles.geo.admin.ch/styles/ch.swisstopo.lightbasemap.vt/style.json',
            center: [8.2, 46.8],
            zoom: 7,
        });
        DirectoryPlace.map.addControl(new maplibregl.NavigationControl());
        // When the map is loaded, update the markers
        DirectoryPlace.map.on('load', () => {
            if (sessionStorage.getItem('directory_map_visible') === 'true') {
                $('#btn-toggle-map').trigger('click');
            }
            else {
                $('#directory-map').addClass('d-none');
            }
        });
    }
    static updatePlacesMarkers() {
        if (!DirectoryPlace.map)
            return;
        const places = Array.from(document.querySelectorAll('[data-place]')).map((el) => {
            var _a;
            const id = el.getAttribute('data-place-id') || '';
            const latitude = parseFloat(el.getAttribute('data-latitude') || '0');
            const longitude = parseFloat(el.getAttribute('data-longitude') || '0');
            const title = ((_a = el.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || '';
            const url = el.href || undefined;
            return { id: id, lat: latitude, lng: longitude, title, url };
        });
        // Remove latitude and longitude from 0
        const validPlaces = places.filter((place) => place.lat !== 0 && place.lng !== 0);
        // Supprimer tous les marqueurs existants
        DirectoryPlace.markers.forEach((marker) => marker.remove());
        DirectoryPlace.markers = [];
        const bounds = new maplibregl.LngLatBounds();
        // Ajouter les nouveaux marqueurs
        for (const place of validPlaces) {
            const marker = new maplibregl.Marker({ color: '#000' })
                .setLngLat([place.lng, place.lat])
                .addTo(DirectoryPlace.map);
            marker.getElement().setAttribute('data-place-id', place.id);
            // On marker hover
            marker.getElement().addEventListener('mouseenter', () => {
                const placeElement = $(`[data-place][data-place-id="${place.id}"]`);
                $('[data-place]').removeClass('highlighted');
                placeElement.addClass('highlighted');
                // If the place is not visible in the list, scroll to it
                if (placeElement && placeElement.position($('.filemaker-list-container')).y < 0 || placeElement.position($('.filemaker-list-container')).y > $('.filemaker-list-container').height()) {
                    //placeElement.get(0).scrollIntoView({ behavior: 'smooth', block: 'center', container: 'nearest' });
                    console.log(placeElement.position($('.filemaker-list-container')).y, $('.filemaker-list').get(0).scrollTop - $('.filemaker-list-container').height() / 2 + placeElement.height() / 2);
                    $('.filemaker-list').get(0).scrollTo({ top: placeElement.position($('.filemaker-list-container')).y + $('.filemaker-list').get(0).scrollTop - $('.filemaker-list-container').height() / 2 + placeElement.height() / 2, behavior: 'smooth' });
                }
                // Change the marker color on hover
                $('.maplibregl-marker').removeClass('highlighted');
                marker.getElement().classList.add('highlighted');
            });
            marker.getElement().addEventListener('mouseleave', () => {
                const placeElement = $(`[data-place-id="${place.id}"]`);
                placeElement.removeClass('highlighted');
                marker.getElement().classList.remove('highlighted');
            });
            // On marker click, go to the place page
            marker.getElement().addEventListener('click', () => {
                if (place.url) {
                    window.location.href = place.url;
                }
            });
            DirectoryPlace.markers.push(marker);
            bounds.extend([place.lng, place.lat]);
        }
        if (validPlaces.length > 0)
            DirectoryPlace.map.fitBounds(bounds, { padding: 40, maxZoom: 14, duration: 0 });
    }
}
DirectoryPlace.markers = [];
